var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 1C7.41775 1 5.87103 1.46919 4.55544 2.34824C3.23985 3.22729 2.21447 4.47672 1.60897 5.93853C1.00347 7.40034 0.84504 9.00887 1.15372 10.5607C1.4624 12.1126 2.22433 13.538 3.34315 14.6569C4.46197 15.7757 5.88743 16.5376 7.43928 16.8463C8.99113 17.155 10.5997 16.9965 12.0615 16.391C13.5233 15.7855 14.7727 14.7602 15.6518 13.4446C16.5308 12.129 17 10.5822 17 9C16.9974 6.87908 16.1536 4.84579 14.6539 3.34607C13.1542 1.84635 11.1209 1.00265 9 1ZM11.8031 9.51231L8.11077 11.9738C8.0095 12.041 7.89073 12.0768 7.76923 12.0769C7.60602 12.0769 7.4495 12.0121 7.33409 11.8967C7.21868 11.7813 7.15385 11.6247 7.15385 11.4615V6.53846C7.15378 6.42702 7.18396 6.31766 7.24119 6.22204C7.29842 6.12642 7.38054 6.04813 7.47878 5.99553C7.57702 5.94294 7.68771 5.918 7.79901 5.9234C7.91032 5.92879 8.01807 5.96431 8.11077 6.02615L11.8031 8.48769C11.8875 8.54387 11.9567 8.62003 12.0046 8.7094C12.0525 8.79878 12.0775 8.8986 12.0775 9C12.0775 9.10139 12.0525 9.20122 12.0046 9.29059C11.9567 9.37997 11.8875 9.45613 11.8031 9.51231Z",
    stroke: "#696974",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.57b90c097be6f19e534a7b011a0fdbfc.svg";
export { ForwardRef as ReactComponent };